/**
 * The conversation family a Commerce Agent run belongs to. Email and SMS keep
 * MarketingChannel's values, so events and threads written before social read unchanged.
 */
export enum ShopperAgentChannel {
  EMAIL = "email",
  SMS = "sms",
  SOCIAL = "social",
  CHAT = "chat",
}
